import instamapsBreadcrumbs from '../shared/components/breadcrumbs/breadcrumbs.vue';
import instamapsGalleryFeatured from './components/gallery-featured/gallery-featured.vue';
import instamapsGalleryList from './components/gallery-list/gallery-list.vue';
import instamapsClonarModal from './components/clonar-modal/clonar-modal.vue';
import messages from './gallery-translations';
import { SharedService } from '../shared/services/sharedService';
import { ApplicationConstants } from '../shared/applicationConstants';


export default {
    name: 'instamapsGallery',
    i18n: {
        messages,
    },
    data: function () {
        return {
            availableMaps: 0,
            lastActivity: new Date(),
            btnUrl: ApplicationConstants.newMapUrl,
            modalIsError: false,
            modalIsLoaded: false,
            modalClonarIsLoaded: false,
            currentMapa: {},
        };
    },
    props: {
        selectedLang: { type: String },
        hasBreadcrumbs: { type: Boolean },
    },
    components: {
        instamapsBreadcrumbs,
        instamapsGalleryFeatured,
        instamapsGalleryList,
        instamapsClonarModal,
    },
    filters: {
        dateFormat: (value) => SharedService.dateFormat(value),
    },
    computed: {
        _availableMaps: function () {
            return this.availableMaps;
        },
        _lastActivity: function () {
            return this.lastActivity;
        },
    },
    methods: {
        updateStats: function (ev) {
            this.availableMaps = ev.availableMaps;
            this.lastActivity = ev.lastActivity;
        },
        loading: function () {
            this.$emit('loading');
        },
        loaded: function (ev) {
            this.updateStats(ev);
            this.$emit('loaded');
        },
        login: function (){
            this.$emit('login');
        },
        showModalClonar: function(ev){
            this.currentMapa = ev.mapa;
            this.modalIsError = false;
            this.modalClonarIsLoaded = true;
        },
        loadedClonar: function(){
            this.modalIsError = false;
            this.modalClonarIsLoaded = false;
        },
        showModalError: function(ev){
            this.modalTitle = ev.title;
            this.modalMessage = ev.message;
            this.modalIsError = true;
            this.modalIsLoaded = true;
        },
    }
};



// WEBPACK FOOTER //
// ./src/gallery/gallery.js